query GetTrackingSnippetPageFeatures {
    trackingSnippetPageFeatures {
        key
        statusText
        status
    }
}
